// import React, { useState } from "react";
// import {
// Dialog,
// DialogContent,
// DialogTitle,
// DialogActions,
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import ReviewPage from "../Review/Reviewpage";

// const SubmitExamDialog = ({
// open,
// onClose,
// answeredCount,
// notAnsweredCount,
// markedCount,
// isAuto = false,
// examId,
// examEmployeeId,
// unansweredMandatoryCount,
// }) => {
// const [showSuccess, setShowSuccess] = useState(false);
// const [showReviewModal, setShowReviewModal] = useState(false);
// const navigate = useNavigate();

// const handleSubmit = () => {
//     // Mock submission
//     setTimeout(() => {
//     setShowSuccess(true);
//     onClose();
//     }, 800);
// };

// const handleCloseSuccess = () => {
//     setShowSuccess(false);
//     navigate("/users/dashboard");
// };

// const handleViewResults = () => {
//     setShowSuccess(false);
//     setShowReviewModal(true);
// };

// return (
//     <>
//     {/* Confirmation Dialog */}
//         <Dialog
//             open={open}
//             onClose={isAuto ? null : onClose}
//             disableEscapeKeyDown={isAuto}
//             disableBackdropClick={isAuto}
//         >
//             <DialogTitle>Submit Exam?</DialogTitle>
//             <DialogContent>
//             {unansweredMandatoryCount > 0 ? (
//                 <p style={{ color: "red", fontWeight: "600" }}>
//                 ⚠ You still have {unansweredMandatoryCount} mandatory questions unanswered.
//                 Are you sure you want to submit?
//                 </p>
//             ) : (
//                 <p>Are you sure you want to submit? This action cannot be undone.</p>
//             )}

//             <div className="submit-summary">
//                 <p>✅ Answered: {answeredCount}</p>
//                 <p>❌ Not Answered: {notAnsweredCount}</p>
//                 <p>📌 Marked for Review: {markedCount}</p>
//             </div>
//             </DialogContent>

//             <DialogActions className="px-3 pb-3">
//             {!isAuto && (
//                 <button
//                 className="btn btn-outline-secondary submit-cancel-btn"
//                 onClick={onClose}
//                 >
//                 Cancel / Return
//                 </button>
//             )}
//             <button
//                 className="btn btn-primary final-submit-btn"
//                 onClick={handleSubmit}
//                 autoFocus
//             >
//                 Submit Final
//             </button>
//             </DialogActions>
//         </Dialog>

//         {/* Success Modal */}
//         {showSuccess && (
//             <div style={{
//             position: "fixed",
//             inset: 0,
//             background: "rgba(0,0,0,0.6)",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             zIndex: 1500
//             }}>
//             <div style={{
//                 background: "white",
//                 borderRadius: "12px",
//                 padding: "32px",
//                 maxWidth: "480px",
//                 textAlign: "center"
//             }}>
//                 <h2 style={{ color: "#0191c8", marginBottom: "24px" }}>
//                 Exam Submitted Successfully!
//                 </h2>
//                 <p style={{ marginBottom: "32px" }}>Thank you for completing the test.</p>
//                 <div style={{ display: "flex", gap: "16px", justifyContent: "center" }}>
//                 <button
//                     onClick={handleCloseSuccess}
//                     style={{
//                     padding: "10px 24px",
//                     borderRadius: "6px",
//                     border: "1px solid #ccc"
//                     }}
//                 >
//                     Close
//                 </button>
//                 <button
//                     onClick={handleViewResults}
//                     style={{
//                     padding: "10px 24px",
//                     borderRadius: "6px",
//                     background: "#0191c8",
//                     color: "white",
//                     border: "none"
//                     }}
//                 >
//                     View Results
//                 </button>
//                 </div>
//             </div>
//             </div>
//         )}

//     {/* Review Modal */}
//     <Dialog
//         open={showReviewModal}
//         onClose={() => {
//         setShowReviewModal(false);
//         navigate("/users/dashboard");
//         }}
//         fullWidth
//         maxWidth="lg"
//     >
//         <DialogTitle>Exam Review</DialogTitle>
//         <DialogContent dividers>
//         <ReviewPage examEmployeeId={examEmployeeId} />
//         </DialogContent>
//         <DialogActions>
//         <button
//             className="btn btn-outline-secondary"
//             onClick={() => {
//             setShowReviewModal(false);
//             navigate("/users/dashboard");
//             }}
//         >
//             Close
//         </button>
//         </DialogActions>
//     </Dialog>
//     </>
// );
// };

// export default SubmitExamDialog;


import React, { useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const SubmitExamDialogDemo = ({
    open,
    onClose,
    answeredCount,
    notAnsweredCount,
    markedCount,
    isAuto = false,
    examId,
    examEmployeeId,
    unansweredMandatoryCount,
}) => {
    const [showSuccess, setShowSuccess] = useState(false);
    const [showReviewModal, setShowReviewModal] = useState(false);
    const navigate = useNavigate();

    // Mock submission – NO API CALL, just simulate success
    const handleSubmit = () => {
        // Fake delay for realism
        setTimeout(() => {
            setShowSuccess(true);
            onClose(); // Close confirmation dialog
        }, 800);
    };

    const handleCloseSuccess = () => {
        setShowSuccess(false);
        navigate("/users/dashboard");
    };

    const handleViewResults = () => {
        setShowSuccess(false);
        setShowReviewModal(true);
    };

    return (
        <>
            {/* Confirmation Dialog */}
            <Dialog
                open={open}
                onClose={isAuto ? null : onClose}
                disableEscapeKeyDown={isAuto}
                disableBackdropClick={isAuto}
            >
                <DialogTitle>Submit Exam?</DialogTitle>
                <DialogContent>
                    {unansweredMandatoryCount > 0 ? (
                        <p style={{ color: "red", fontWeight: "600" }}>
                            ⚠ You still have {unansweredMandatoryCount} mandatory questions unanswered.
                            Are you sure you want to submit?
                        </p>
                    ) : (
                        <p>Are you sure you want to submit? This action cannot be undone.</p>
                    )}

                    <div className="submit-summary">
                        <p>✅ Answered: {answeredCount}</p>
                        <p>❌ Not Answered: {notAnsweredCount}</p>
                        <p>📌 Marked for Review: {markedCount}</p>
                    </div>
                </DialogContent>

                <DialogActions className="px-3 pb-3">
                    {!isAuto && (
                        <button
                            className="btn btn-outline-secondary submit-cancel-btn"
                            onClick={onClose}
                        >
                            Cancel / Return
                        </button>
                    )}
                    <button
                        className="btn btn-primary final-submit-btn mock1"
                        onClick={handleSubmit}
                        autoFocus
                    >
                        Submit Final
                    </button>
                </DialogActions>
            </Dialog>

            {/* Success Modal */}
            {showSuccess && (
                <div
                    style={{
                        position: "fixed",
                        inset: 0,
                        background: "rgba(0,0,0,0.6)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 1500,
                    }}
                >
                    <div
                        style={{
                            background: "white",
                            borderRadius: "12px",
                            padding: "32px",
                            maxWidth: "480px",
                            textAlign: "center",
                        }}
                    >
                        <h2 style={{ color: "#0191c8", marginBottom: "24px" }}>
                            Exam Submitted Successfully!
                        </h2>
                        <p style={{ marginBottom: "32px" }}>Thank you for completing the test.</p>
                        <div style={{ display: "flex", gap: "16px", justifyContent: "center" }}>
                            <button
                                className="success-close-btn"
                                onClick={handleCloseSuccess}
                                style={{
                                    padding: "10px 24px",
                                    borderRadius: "6px",
                                    border: "1px solid #ccc",
                                }}
                            >
                                Close
                            </button>
                            <button
                                className="success-view-btn"
                                onClick={handleViewResults}
                                style={{
                                    padding: "10px 24px",
                                    borderRadius: "6px",
                                    background: "#0191c8",
                                    color: "white",
                                    border: "none",
                                }}
                            >
                                View Results
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Review Modal */}
            {/* <Dialog
                open={showReviewModal}
                onClose={() => {
                    setShowReviewModal(false);
                    navigate("/users/dashboard");
                }}
                fullWidth
                maxWidth="lg"
            >
                <DialogTitle>Exam Review</DialogTitle>
                <DialogContent dividers>
                    <ReviewPage examEmployeeId={examEmployeeId} />
                </DialogContent>
                <DialogActions>
                    <button
                        className="btn btn-outline-secondary"
                        onClick={() => {
                            setShowReviewModal(false);
                            navigate("/users/dashboard");
                        }}
                    >
                        Close
                    </button>
                </DialogActions>
            </Dialog> */}
        </>
    );
};

export default SubmitExamDialogDemo;